export default "__VITE_ASSET__BPqQrsjE__"